import { render, staticRenderFns } from "./SFDW.vue?vue&type=template&id=0968306f&scoped=true"
import script from "./SFDW.vue?vue&type=script&lang=js"
export * from "./SFDW.vue?vue&type=script&lang=js"
import style0 from "./SFDW.vue?vue&type=style&index=0&id=0968306f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968306f",
  null
  
)

export default component.exports